import type {
  DeterministicAnalysisResult,
  SessionRepairStatus,
} from '../types';

type DeriveSessionRepairStatusInput = {
  hasHrData: boolean;
  hasHrDataRepaired: boolean;
  analysis?: DeterministicAnalysisResult | null;
  isAnalyzing?: boolean;
  analysisFailed?: boolean;
};

export const deriveSessionRepairStatus = ({
  hasHrData,
  hasHrDataRepaired,
  analysis,
  isAnalyzing = false,
  analysisFailed = false,
}: DeriveSessionRepairStatusInput): SessionRepairStatus => {
  if (!hasHrData) {
    return 'no_hr_data';
  }

  if (hasHrDataRepaired) {
    return 'repaired_perfect';
  }

  if (isAnalyzing) {
    return 'analyzing';
  }

  if (analysisFailed) {
    return 'analysis_failed';
  }

  if (!analysis) {
    return 'not_analyzed';
  }

  if (analysis.status === 'clean') {
    return 'perfect';
  }

  return 'needs_repair';
};
